import React, { useContext, useEffect } from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Slider from '@mui/material/Slider';
import { ColorPicker } from 'mui-color';
import AppContext from '../../context/AppContext';
function valueText(value) {
  return `${value}`;
}
const QRSettings = () => {
  const { data, setData } = useContext(AppContext);

  return (
    <Accordion sx={{ width: '100%' }}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <Typography color="primary" variant="body2">
          <strong>QR Options</strong>
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Stack sx={{ width: 1 }} direction="column" spacing={2}>
          {/* Size Width */}
          <Stack
            spacing={2}
            justifyContent="space-between"
            alignItems="center"
            direction="row"
          >
            <Typography sx={{ mr: 4, width: 'auto' }}>Size</Typography>
            <Slider
              sx={{ width: 4 / 5 }}
              defaultValue={16}
              onChange={(e, newValue) =>
                setData({
                  ...data,
                  qrSettings: {
                    ...data.qrSettings,
                    size: newValue,
                  },
                })
              }
              getAriaValueText={valueText}
              valueLabelDisplay="auto"
              step={16}
              value={data.qrSettings.size}
              marks
              min={16}
              max={512}
            />
          </Stack>
          {/* Correction Level */}
          <Stack
            spacing={2}
            justifyContent="start"
            alignItems="center"
            direction="row"
          >
            <Typography sx={{ mr: 10, width: 'auto' }}>High</Typography>
            <Select
              color="primary"
              variant="filled"
              value={data.qrSettings.errorCorrectionLevel}
              onChange={(e) =>
                setData({
                  ...data,
                  qrSettings: {
                    ...data.qrSettings,
                    errorCorrectionLevel: e.target.value,
                  },
                })
              }
            >
              <MenuItem value="H">
                <em>High</em>
              </MenuItem>
              <MenuItem value="M">
                <em>Medium</em>
              </MenuItem>
              <MenuItem value="L">
                <em>Low</em>
              </MenuItem>
            </Select>
          </Stack>

          {/* Background Color */}
          <Stack
            spacing={2}
            justifyContent="start"
            alignItems="center"
            direction="row"
          >
            <Typography sx={{ mr: 2.1, width: 'auto' }}>
              Background Color
            </Typography>
            <ColorPicker
              value={data.qrSettings.backgroundColor}
              defaultValue={data.qrSettings.backgroundColor}
              onChange={(value) =>
                setData({
                  ...data,
                  qrSettings: {
                    ...data.qrSettings,
                    backgroundColor: `#${value.hex}`,
                  },
                })
              }
            />
          </Stack>
          {/* Foreground Color */}
          <Stack
            spacing={2}
            justifyContent="start"
            alignItems="center"
            direction="row"
          >
            <Typography sx={{ mr: 4, width: 'auto' }}>
              Foreground Color
            </Typography>
            <ColorPicker
              value={data.qrSettings.foregroundColor}
              defaultValue={data.qrSettings.foregroundColor}
              onChange={(value) =>
                setData({
                  ...data,
                  qrSettings: {
                    ...data.qrSettings,
                    foregroundColor: `#${value.hex}`,
                  },
                })
              }
            />
          </Stack>
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
};

export default QRSettings;
